"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MethodManager_1 = require("../../../../TdWebtoolkitControls/controls/Menu/MethodManager");
let obj = {
    matches: ["executeOnSelection"],
    execute: (_commandName, commandOptions) => {
        MethodManager_1.MethodManager.executeMethod(commandOptions.menuEntry, commandOptions.ids, commandOptions.parentId, commandOptions.relId, undefined, commandOptions.commandOptions);
        return Promise.resolve();
    },
    isBreadcrumbElement: false
};
exports.default = obj;
